import { MdErrorOutline } from 'react-icons/md';
import './NotFound.css';

export function NotFound() {
	return (
		<div className='container'>
			<div className='not-found-wrapper'>
				<MdErrorOutline size={72} color='#ff6d6d' />
				<h2>Página não encontrada!</h2>
				<p>A página ou recurso que você tentou acessar não existe em nosso sistema.<br /> Por favor, verifique a url.</p>
			</div>
		</div>
	);
}